<template>
  <div>
    <img src="@/assets/tarjeta_promocion_aspirador.jpg" style="width: 100%" />
    <p class="tituloTarjeta">PROMOCIÓN DE VERANO: ASPIRADOR DE REGALO</p>
    <p>
      Contratando tu seguro de hogar o de negocios te regalamos <b> un aspirador vertical 2 en 1 Petfriend. </b>
    </p>
   
    <ul style="list-style-type: disc">
      <li>Protección para tu hogar o negocio</li>
      <li>Coberturas adaptadas a tus necesidades</li>
      <li>Atención cercana y personalizada</li>
      <li>Y además..., un regalo para tu día a día</li>
    </ul>
   
    <p>
      <b>Infórmate en tu oficina</b>
    </p>
  
    <p class="container-flex">
      <a :href="'tel:' + telefonoOwner">
        <button class="pure-button botonLlamar" title="Pulsa el botón para llamar a tu oficina MMT">
          Llamar  oficina
        </button>
      </a>
    </p>
   
  </div>
</template>

<script>
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}
</style>
